<ng-scrollbar class="w-full flex flex-col max-h-[100%]" [visibility]="'hover'" [autoHeightDisabled]="false">
  <palantir-layout class="h-full w-full">
    <div palantir-layout-content class="flex flex-col gap-4 palantir-scrollbar">
      <palantir-content>
        <div class="flex flex-col gap-2">
          <div class="w-full grid grid-cols-2">
            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.VALUE' | translate">
              @if (isViewMode()) {
                <palantir-text type="title">
                  {{ warrantyForm.get('value')?.value ?? 0 | currencyFormat }}
                </palantir-text>
              } @else if (warrantyEditForm) {
                <ng-container>
                  <input type="text" [formControl]="warrantyEditForm | getControl: 'value'" currencyMask />

                  <palantir-input-error>
                    @if (warrantyEditForm.get('value')?.hasError('required')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.REQUIRED' | translate }}
                      </palantir-text>
                    }
                    @if (warrantyEditForm.get('value')?.hasError('min')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.VALUE_MIN' | translate: { value: 0 } }}
                      </palantir-text>
                    }
                    @if (warrantyEditForm.get('value')?.hasError('max')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.MAX' | translate }}
                      </palantir-text>
                    }
                  </palantir-input-error>
                </ng-container>
              }
            </palantir-input>

            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.CONVERAGE_DAYS' | translate">
              @if (isViewMode()) {
                <palantir-text type="title">
                  {{ warrantyForm.get('coverageDurationDays')?.value }}
                  {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.CARD.DAYS' | translate }}
                </palantir-text>
              } @else if (warrantyEditForm) {
                <ng-container>
                  <input [formControl]="warrantyEditForm | getControl: 'coverageDurationDays'" type="number" min="0" />

                  <palantir-input-error>
                    @if (warrantyEditForm.get('coverageDurationDays')?.hasError('required')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.REQUIRED' | translate }}
                      </palantir-text>
                    }
                    @if (warrantyEditForm.get('coverageDurationDays')?.hasError('min')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.DAY_MIN' | translate: { days: 1 } }}
                      </palantir-text>
                    }
                    @if (warrantyEditForm.get('coverageDurationDays')?.hasError('max')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.MAX' | translate }}
                      </palantir-text>
                    }
                  </palantir-input-error>
                </ng-container>
              }
            </palantir-input>

            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.START_DATE' | translate">
              <palantir-text type="title">
                @let startedAt =
                  isViewMode() ? warrantyForm.get('coverageStartedAt')?.value : warrantyEditForm?.get('coverageStartedAt')?.value;
                @if (startedAt) {
                  {{ startedAt | date: 'dd/MM/yyyy' }}
                } @else {
                  -
                }
              </palantir-text>
            </palantir-input>

            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.END_DATE' | translate">
              <palantir-text type="title">
                @let endDate =
                  isViewMode() ? warrantyForm.get('coverageEndedAt')?.value : warrantyEditForm?.get('coverageEndedAt')?.value;
                @if (startedAt) {
                  {{ endDate | date: 'dd/MM/yyyy' }}
                } @else {
                  -
                }
              </palantir-text>
            </palantir-input>
          </div>
          <palantir-layout class="w-full p-3 card">
            <div class="flex items-center gap-2">
              <palantir-icon name="warranty-outline"></palantir-icon>
              <palantir-text type="title">
                {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.WARRANTY_EXTENDED' | translate }}
              </palantir-text>
            </div>
            @if (!isViewMode() && warrantyEditForm) {
              <palantir-input
                cdkListbox
                [cdkListboxValue]="[warrantyEditForm.get('hasCoverageExtend')?.value]"
                (cdkListboxValueChange)="warrantyEditForm.get('hasCoverageExtend')?.setValue($event.value[0] ?? null)"
              >
                <div class="flex gap-3 p-2">
                  <palantir-radio [cdkOption]="false" label="{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.DISABLE' | translate }}">
                  </palantir-radio>
                  <palantir-radio [cdkOption]="true" label="{{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.ENABLE' | translate }}">
                  </palantir-radio>
                </div>
              </palantir-input>
            }
            @let hasCoverageExtend =
              isViewMode() ? warrantyForm.get('hasCoverageExtend')?.value : warrantyEditForm?.get('hasCoverageExtend')?.value;
            @if (hasCoverageExtend) {
              <div class="w-full grid grid-cols-2">
                <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.EXTENDED_VALUE' | translate">
                  @if (isViewMode()) {
                    <palantir-text type="title">
                      {{ warrantyForm.get('extendedValue')?.value ?? 0 | currencyFormat }}
                    </palantir-text>
                  } @else if (warrantyEditForm) {
                    <ng-container>
                      <input type="text" [formControl]="warrantyEditForm | getControl: 'extendedValue'" currencyMask />

                      <palantir-input-error>
                        @if (warrantyEditForm.get('extendedValue')?.hasError('required')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.REQUIRED' | translate }}
                          </palantir-text>
                        }
                        @if (warrantyEditForm.get('extendedValue')?.hasError('min')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.VALUE_MIN' | translate: { value: 1 } }}
                          </palantir-text>
                        }
                        @if (warrantyEditForm.get('extendedValue')?.hasError('max')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.MAX' | translate }}
                          </palantir-text>
                        }
                      </palantir-input-error>
                    </ng-container>
                  }
                </palantir-input>

                <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.EXTENDED_CONVERAGE_DAYS' | translate">
                  @if (isViewMode()) {
                    <palantir-text type="title">
                      {{ warrantyForm.get('extendedCoverageDurationDays')?.value }}
                      {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.CARD.DAYS' | translate }}
                    </palantir-text>
                  } @else if (warrantyEditForm) {
                    <ng-container>
                      <input [formControl]="warrantyEditForm | getControl: 'extendedCoverageDurationDays'" type="number" min="0" />

                      <palantir-input-error>
                        @if (warrantyEditForm.get('extendedCoverageDurationDays')?.hasError('required')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.REQUIRED' | translate }}
                          </palantir-text>
                        }
                        @if (warrantyEditForm.get('extendedCoverageDurationDays')?.hasError('min')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.DAY_MIN' | translate: { days: 1 } }}
                          </palantir-text>
                        }
                        @if (warrantyEditForm.get('extendedCoverageDurationDays')?.hasError('max')) {
                          <palantir-text type="negative" size="xs">
                            {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.MAX' | translate }}
                          </palantir-text>
                        }
                      </palantir-input-error>
                    </ng-container>
                  }
                </palantir-input>

                <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.START_DATE' | translate">
                  <palantir-text type="title">
                    @let endDate =
                      isViewMode() ? warrantyForm.get('coverageEndedAt')?.value : warrantyEditForm?.get('coverageEndedAt')?.value;
                    @if (startedAt) {
                      {{ endDate | date: 'dd/MM/yyyy' }}
                    } @else {
                      -
                    }
                  </palantir-text>
                </palantir-input>

                <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.END_DATE' | translate">
                  <palantir-text type="title">
                    @let extendedEndDate =
                      isViewMode()
                        ? warrantyForm.get('extendedCoverageEndedAt')?.value
                        : warrantyEditForm?.get('extendedCoverageEndedAt')?.value;
                    @if (startedAt) {
                      {{ extendedEndDate | date: 'dd/MM/yyyy' }}
                    } @else {
                      -
                    }
                  </palantir-text>
                </palantir-input>
              </div>
            } @else {
              <div class="flex justify-center">
                <palantir-text type="description">
                  {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.NO_EXTENDED' | translate }}
                </palantir-text>
              </div>
            }
          </palantir-layout>
          <div>
            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.MAINTENANCE_TYPE' | translate">
              <palantir-text type="title">
                @let maintenanceTypes = warrantyForm.get('maintenancesTypes')?.value;
                @if (maintenanceTypes?.length) {
                  {{ maintenanceTypes }}
                } @else {
                  {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.EMPTY' | translate }}
                }
              </palantir-text>
            </palantir-input>

            <palantir-input [label]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.DESCRIPTION' | translate">
              @if (isViewMode()) {
                <palantir-text type="title">
                  {{ warrantyForm.get('description')?.value }}
                </palantir-text>
              } @else if (warrantyEditForm) {
                <ng-container>
                  <textarea
                    class="w-full"
                    [formControl]="warrantyEditForm | getControl: 'description'"
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5"
                    [placeholder]="'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.INPUTS.DESCRIPTION' | translate"
                    maxlength="2000"
                  ></textarea>

                  <palantir-input-error>
                    @if (warrantyEditForm.get('description')?.hasError('required')) {
                      <palantir-text type="negative" size="xs">
                        {{ 'TAB_WARRANTIES_MAINTENANCE.WARRANTIES.ERRORS.REQUIRED' | translate }}
                      </palantir-text>
                    }
                  </palantir-input-error>
                </ng-container>
              }
            </palantir-input>
          </div>
        </div>
        <div class="flex items-center justify-end gap-3">
          @if (
            maintenanceTabWarrantiesService.selectedWarrantyType() === WARRANTY_TYPE.MAINTENANCES &&
            maintenanceTabWarrantiesService.hasEditWarrantyPermission()
          ) {
            @if (isViewMode()) {
              <palantir-button
                size="2xs"
                variant="negative"
                theme="outline"
                layout="prefix"
                icon="remove-outline"
                (click)="removeWarranty()"
              >
                {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.REMOVE' | translate }}
              </palantir-button>
              <palantir-button size="2xs" theme="outline" layout="prefix" icon="edit-outline" (click)="toggleEdit()">
                {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.EDIT' | translate }}
              </palantir-button>
            } @else {
              <palantir-button
                size="2xs"
                variant="negative"
                theme="outline"
                layout="prefix"
                icon="close-outline"
                (click)="cancelEdit()"
              >
                {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.CANCEL' | translate }}
              </palantir-button>
              <palantir-button size="2xs" theme="outline" layout="prefix" icon="check-outline" (click)="saveWarranty()">
                {{ 'TAB_WARRANTIES_MAINTENANCE.BUTTON.SAVE' | translate }}
              </palantir-button>
            }
          }
        </div>
      </palantir-content>
    </div>
  </palantir-layout>
</ng-scrollbar>
